import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const PAY_PAGE_MAIN_MOBILE_MOBILE_PAYMENT_CONTAINER = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'PAY_PAGE_MAIN_MOBILE_MOBILE_PAYMENT_CONTAINER')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'test.json',
      requestAction: PAY_PAGE_MAIN_MOBILE_MOBILE_PAYMENT_CONTAINER.INIT_REQUEST,
      successAction: PAY_PAGE_MAIN_MOBILE_MOBILE_PAYMENT_CONTAINER.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAY_PAGE_MAIN_MOBILE_MOBILE_PAYMENT_CONTAINER.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAY_PAGE_MAIN_MOBILE_MOBILE_PAYMENT_CONTAINER.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'payPageMainMobileMobilePaymentContainer',
    reducerMap: {
      payPageMainMobileMobilePaymentContainerState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
